import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  Article,
  PaginatedArticlesResponse,
  RequestResponse,
} from '@/types';

export const fetchArticles = async (search?: string) => {
  const response = await axiosInstance<
    RequestResponse<PaginatedArticlesResponse>
  >(endpoints.support.articles, {
    params: search && search.trim() ? { search: search.trim() } : undefined,
  });
  const data = response.data.data;
  return data
    ? {
        ...data,
        data: Array.isArray(data.data) ? data.data : [],
      }
    : {
        nextPage: 0,
        currentPage: 1,
        lastPage: 0,
        currentPagesize: 0,
        total: 0,
        data: [] as Article[],
      };
};

export const fetchArticle = async (id: number | string) => {
  const response = await axiosInstance<RequestResponse<Article>>(
    `${endpoints.support.articles}/${id}`
  );
  return response.data.data;
};
